export default "__VITE_ASSET__BxAQ24XE__"